import type {
  CoreDataType,
  DataTypesQuizQuestion,
  PreviewType,
} from "~/features/python/ch2/data-types/types/dataTypes.types";

export const coreDataTypes: CoreDataType[] = [
  {
    id: "int",
    title: "Integer",
    pythonName: "int",
    explanation: "Integer woh number hota hai jisme decimal point nahi hota.",
    realWorldExample: "Class ke total students 45 hon to yeh int hoga.",
    code: "students = 45\nprint(type(students))",
  },
  {
    id: "float",
    title: "Float",
    pythonName: "float",
    explanation: "Float decimal wala number hota hai.",
    realWorldExample: "BMI ya height jaisi values 5.7 ya 1.75 float hoti hain.",
    code: "height = 1.75\nprint(type(height))",
  },
  {
    id: "string",
    title: "String",
    pythonName: "str",
    explanation: "String text hota hai jo quotes ke andar likha jata hai.",
    realWorldExample: "Student ka naam \"Ali\" string hoga.",
    code: "name = \"Ali\"\nprint(type(name))",
  },
  {
    id: "bool",
    title: "Boolean",
    pythonName: "bool",
    explanation: "Boolean sirf do values rakhta hai: True ya False.",
    realWorldExample: "Attendance complete hai ya nahi, yeh bool se show hota hai.",
    code: "is_pass = True\nprint(type(is_pass))",
  },
];

export const previewTypes: PreviewType[] = [
  {
    id: "list",
    title: "List",
    explanation: "List multiple values ko aik jagah rakhti hai aur order maintain karti hai.",
    ctaLabel: "Learn in Chapter 3",
  },
  {
    id: "tuple",
    title: "Tuple",
    explanation: "Tuple bhi multiple values rakhta hai, lekin isay fixed group samjho.",
    ctaLabel: "Learn in Chapter 3",
  },
];

export const dataTypesQuizQuestions: DataTypesQuizQuestion[] = [
  {
    id: "dt-q1",
    question: "Python mein 5.2 kis type ka example hai?",
    options: ["int", "float", "str", "bool"],
    correctIndex: 1,
    explanation: "Decimal wali value float hoti hai.",
  },
  {
    id: "dt-q2",
    question: "\"hello\" kis type ka example hai?",
    options: ["bool", "float", "str", "int"],
    correctIndex: 2,
    explanation: "Quotes ke andar text string hota hai.",
  },
  {
    id: "dt-q3",
    question: "True Python mein kis type ka example hai?",
    options: ["bool", "str", "float", "int"],
    correctIndex: 0,
    explanation: "True aur False boolean values hoti hain.",
  },
  {
    id: "dt-q4",
    question: "int(\"12\") ka result kya banay ga?",
    options: ["12 as int", "\"12\" as string", "Error", "12.0"],
    correctIndex: 0,
    explanation: "String number ko int() integer mein convert kar deta hai.",
  },
  {
    id: "dt-q5",
    question: "float(\"Ali\") ka kya hoga?",
    options: ["Ali", "0.0", "Error", "True"],
    correctIndex: 2,
    explanation: "Non-numeric text ko float mein convert nahi kiya ja sakta.",
  },
];

export const dataTypesFaqs = [
  {
    question: "Python data type kya hota hai?",
    answer: "Data type batata hai ke variable mein kis qisam ki value rakhi gayi hai, jaise int, float, string ya bool.",
  },
  {
    question: "int aur float mein farq kya hai?",
    answer: "int decimal ke baghair number hota hai, jab ke float decimal wala number hota hai.",
  },
];
